import { toast } from "react-toastify";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiConnector } from "../apiConnector";
import { endpoint } from "../apis";
import { setLoading } from "src/store/slices/authSlice";
import Cookies from "js-cookie";

// AsyncThunk to fetch youtube channels
export const fetchYoutubeChannels = createAsyncThunk(
  // Action Type,
  "youtube/fetchYoutubeChannels",
  async (_, { rejectWithValue }) => {
    const token = Cookies.get("authToken");
    try {
      const response = await apiConnector(
        "get",
        endpoint.CHANNELS,
        null,
        { Authorization: `Bearer ${token}` },
        null
      );

      // Handle new response format: { youtube: [...], instagram: [...] }
      let channels = [];
      
      if (response.data && typeof response.data === 'object') {
        // Check if it's the new format with youtube/instagram keys
        if (response.data.youtube && Array.isArray(response.data.youtube)) {
          channels = response.data.youtube;
        } else if (Array.isArray(response.data)) {
          // Fallback: if it's still an array (backward compatibility)
          channels = response.data;
        } else {
          // Unexpected format
          toast.error(
            "Failed to fetch channels, or the data is not in the expected format!"
          );
          return rejectWithValue("Unexpected response format");
        }
      } else {
        // No data or invalid format
        toast.error(
          "Failed to fetch channels, or the data is not in the expected format!"
        );
        return rejectWithValue("Invalid response data");
      }
      
      if (channels.length === 0) {
        toast.success("No channel found!!");
        return channels;
      } else {
        toast.success("Channels fetched successfully!");
        return channels;
      }
    } catch (error) {
      // Check if the error response indicates token expiration
      if (error?.response?.data == "('Token has been expired',)") {
        localStorage.clear();
        window.location.href = "/";
        toast.error("Session expired. Please log in again.");
      } else {
        toast.error(error.response?.data || "Failed to fetch channels!");
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const delinkChannel = createAsyncThunk(
  "youtube/delinkChannnel",
  async ({ channelId }, { dispatch, rejectWithValue }) => {
    // const token = localStorage.getItem('jwt_token');
    const token = Cookies.get("authToken");
    try {
      // Set loading state to true manually
      // dispatch(setLoading(true));

      const response = await apiConnector(
        "post",
        endpoint.CHANNEL_DELETE,
        {
          channel_id: channelId,
        },
        { Authorization: `Bearer ${token}` },
        null
      );
      dispatch(fetchYoutubeChannels());
      toast.success("Channel delinked successfully!");
      return response.data;
    } catch (error) {
      if (error?.response?.data == "('Token has been expired',)") {
        localStorage.clear();
        window.location.href = "/";
        toast.error("Session expired. Please log in again.");
      } else {
        toast.error(error.response?.data || "Failed to fetch channels!");
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const handleSubmit = createAsyncThunk(
  "youtube/handleSubmit",
  async ({ channelEditId, channelName }, { rejectWithValue }) => {
    // const token = localStorage.getItem('token');
    const token = Cookies.get("authToken");
    try {
      const response = await apiConnector(
        "post",
        endpoint.CHANNEL_EDIT,
        {
          channel_id: channelEditId,
          channel_name: channelName,
        },
        {
          Authorization: `Bearer ${token}`,
        },
        null
      );
      toast.success("Form Submitted Successfully!");
      // Step 2: After edit, fetch the updated channel details
      const fetchResponse = await apiConnector("get", endpoint.CHANNELS, null, {
        Authorization: `Bearer ${token}`,
      });

      // Step 3: Handle new response format and return the updated channel data
      let channels = [];
      
      if (fetchResponse.data && typeof fetchResponse.data === 'object') {
        // Check if it's the new format with youtube/instagram keys
        if (fetchResponse.data.youtube && Array.isArray(fetchResponse.data.youtube)) {
          channels = fetchResponse.data.youtube;
        } else if (Array.isArray(fetchResponse.data)) {
          // Fallback: if it's still an array (backward compatibility)
          channels = fetchResponse.data;
        } else {
          // Unexpected format
          toast.error(
            "Failed to fetch channels, or the data is not in the expected format!"
          );
          return rejectWithValue("Unexpected response format");
        }
      } else {
        // No data or invalid format
        toast.error(
          "Failed to fetch channels, or the data is not in the expected format!"
        );
        return rejectWithValue("Invalid response data");
      }
      
      toast.success("Channel data edited successfully!");
      return channels;
    } catch (error) {
      if (error?.response?.data == "('Token has been expired',)") {
        localStorage.clear();
        window.location.href = "/";
        toast.error("Session expired. Please log in again.");
      } else {
        toast.error(error.response?.data || "Failed to fetch channels!");
      }
      return rejectWithValue(error.response.data);
    }
  }
);
